import ViewBase from "../../../../framework/core/mvvm/view_base";
import { SlotGame } from "../../net/proto/proto_slot_game";
import ModelData, { IUserData } from "../../../public/model_data";
import EventManager from "../../../../manager/event_manager";
import Utility from "../../../../utility/utility";
import { SpriteHolderSlot } from "../sprite_holder_slot";
import { SlotButtonGrey } from "../button_grey_slot";
import SlotTableSound from "./slot_table_sound";
import GameUtil from "../../../../utility/game_util";
import SlotTableLine from "./slot_table_line";
import { AnimHolderSlot } from "../anim_holder_slot";
import { SlotData, SlotFruit, SlotGrid } from "./slot_data";
import { SlotCycleEvent } from "./slot_cycle_event";
import TableBaseView from "../../../table/module/table_base/table_base_view";
import TablePlayerAvatar from "../../../table/components/table_player_avatar";

const { ccclass, property } = cc._decorator;

@ccclass
export default class SlotTableView extends TableBaseView {
    @property(cc.Node)
    gridParent: cc.Node = null
    @property(cc.Node)
    gridAnimParent: cc.Node = null
    @property(cc.Button)
    startBtn: cc.Button = null
    @property(cc.Button)
    stopBtn: cc.Button = null
    @property(cc.Node)
    autoActiveBg: cc.Node = null
    @property(cc.Label)
    payLineCountLabel: cc.Label = null
    @property(cc.Label)
    balanceLabel: cc.Label = null
    @property(cc.Label)
    betLabel: cc.Label = null
    @property(cc.Label)
    selfWinGoldLabel: cc.Label = null
    @property(cc.Node)
    selfAvaterEffect: cc.Node = null
    @property(cc.Node)
    autoFlagNode: cc.Node = null
    @property(cc.Node)
    animNode: cc.Node = null
    @property(cc.Label)
    winAnimNumberLabel: cc.Label = null
    @property(cc.Node)
    animMengban: cc.Node = null
    @property(cc.Node)
    startFreeLabel: cc.Node = null
    @property(SlotButtonGrey)
    buttonGreyManager: SlotButtonGrey = null
    @property(SpriteHolderSlot)
    spriteHoder: SpriteHolderSlot = null
    @property(cc.Node)
    freeEffectNode: cc.Node = null
    @property(cc.Node)
    animContinueBtn: cc.Node = null
    @property(SlotTableLine)
    slotTableLine: SlotTableLine = null
    @property(AnimHolderSlot)
    slotAnim: AnimHolderSlot = null
    @property(cc.Node)
    freeSpinNode: cc.Node = null
    @property(cc.Label)
    freeSpinTimes: cc.Label = null
    @property(cc.Label)
    freeSpinWinGoldLabel: cc.Label = null
    @property(cc.RichText)
    bottomLastWin: cc.RichText = null
    @property(cc.Node)
    bottomLastWinNode: cc.Node = null
    @property(dragonBones.ArmatureDisplay)
    bottomDragonLabel: dragonBones.ArmatureDisplay = null
    @property(cc.Node)
    playerPosNode: cc.Node = null

    playAvatar : TablePlayerAvatar

    slotRoomData: SlotData
    onShow() {
        let self = this
        self.slotRoomData.freeSpinStatus = parseInt(SlotData.getLocalRecord("SlotFreeSpinStatus", "-1"))
        self.generateIconCycleSequence()
        self.initView()
        self.restoreLastResult()

    }
    initView() {
        let self = this
        self.setSelfInfo()
        self.slotRoomData.win_loss = 0
        self.startBtn.node.active = true
        self.stopBtn.node.active = false
        self.freeSpinNode.active = false
        self.payLineCountLabel.string = self.slotRoomData.payLineCount + " กติกาชำระเงิน"
        self.initGrid()
        self.slotTableLine.initLine(self.slotRoomData)
    }
    restoreLastResult() {
        let self = this
        let sr = SlotData.getLocalRecord("SlotLastResult", "")
        let iconStr = SlotData.getLocalRecord("SlotLastIconArray", "")

        let func = function () {
            self.updateWin(1, 0, true)
            if (iconStr == "") {
                self.setResultIcon()
            } else {
                let iconStrs = iconStr.split(",")
                let iconStrArray = []
                for (let i = 0; i < iconStrs.length; i++) {
                    let hang = Math.floor(i / 5)
                    if (!iconStrArray[hang]) {
                        iconStrArray[hang] = []
                    }
                    iconStrArray[hang][i % 5] = iconStrs[i]
                }
                self.setResultIcon(undefined, iconStrArray)
            }
            self.slotTableLine.cycleBaseLine()
            SlotTableSound.playBgm()
        }
        if (sr == "") {
            func()
        } else {
            let lastSlotResult: SlotGame.ISlotResult = JSON.parse(sr)

            if (typeof (lastSlotResult) == "string") {
                func()
            } else {
                let win = lastSlotResult.winAmount != null && lastSlotResult.winAmount != undefined ? lastSlotResult.winAmount : 0
                if (win > 0) {
                    self.slotRoomData.last_win_loss = win
                }
                self.updateWin(1, win, true)
                self.setResultIcon(lastSlotResult)
                if (SlotData.rewardFreeSpinTimes(lastSlotResult) > 0 && self.slotRoomData.freeSpinStatus >= -1) {
                    if (self.slotRoomData.freeSpinStatus == -1) {
                        self.setFreeSpinStatus(0)
                    }
                    self.slotRoomData.reconnectFreeSpin = true
                    self.slotRoomData.slotResult = lastSlotResult
                    self.slotRoomData.currentSlotResult = lastSlotResult
                    let beishu = SlotData.getLocalRecord("SlotFreeSpinBeishu", self.slotRoomData.curMultiple + "")
                    self.slotRoomData.setbigwinCount(parseInt(beishu))
                    if (self.slotRoomData.freeSpinStatus == 0) {
                        self.playFullAnim("freeStart", lastSlotResult.freeSpin.records.length + "")
                    } else {
                        self.startFreeSin(self.slotRoomData.freeSpinStatus, true)
                    }
                    self.clearState()
                    SlotTableSound.playFreeBgm()
                } else if (lastSlotResult.paylines != undefined && lastSlotResult.paylines.length > 0) {
                    self.showBoxLine(lastSlotResult.paylines)
                    SlotTableSound.playBgm()
                } else {
                    self.slotTableLine.cycleBaseLine()
                    SlotTableSound.playBgm()
                }
            }
        }
    }

    setAutoSpin(auto, curMultiple) {
        let self = this
        self.autoFlagNode.active = auto
        if (self.slotRoomData.cycleStatus != 0) {
            return
        }
        self.autoActiveBg.active = auto
        self.buttonGreyManager.setButtonGrey("info", auto)
        self.buttonGreyManager.setButtonGrey("carry", auto)
        if (auto) {
            self.buttonGreyManager.setButtonGrey("add", auto)
            self.buttonGreyManager.setButtonGrey("reduce", auto)
        } else {
            self.buttonGreyManager.setButtonGrey("add", curMultiple == self.slotRoomData.roomRule.maxMultiple)
            self.buttonGreyManager.setButtonGrey("reduce", curMultiple == self.slotRoomData.roomRule.minMultiple)
        }

        self.buttonGreyManager.setButtonGrey("max", auto)
        self.buttonGreyManager.setButtonGrey("stop", auto)
        self.stopBtn.node.active = auto
        self.startBtn.node.active = !self.stopBtn.node.active
    }

    setMultiple(m: number) {
        let self = this
        self.betLabel.string = "$" + self.slotRoomData.payLineCount * m
        self.buttonGreyManager.setButtonGrey("add", m == self.slotRoomData.roomRule.maxMultiple)
        self.buttonGreyManager.setButtonGrey("reduce", m == self.slotRoomData.roomRule.minMultiple)
        self.slotRoomData.setbigwinCount(m)
    }


    setSelfInfo() {
        // let self = this
        // this.getUserData(ModelData.instance.roleData.id, (data: IUserData) => {
        //     self.selfAvater.spriteFrame = data.avatarSprite
        // })
        // if (ModelData.instance.roleData && ModelData.instance.roleData.name) {
        //     self.selfNameLabel.string = GameUtil.cutStr(ModelData.instance.roleData.name)
        // }
        this.playAvatar =  this.addAvatarById(1,ModelData.instance.roleData.id,this.playerPosNode)
    }

    setBtnGrey(btn: cc.Button, grey: boolean) {
        btn.interactable = !grey
        btn.enableAutoGrayEffect = grey
    }

    updateRoomInfo(walletBalance, accountBalance) {
        let self = this
        if (self.slotRoomData.isFirstGameInfo) {
            self.slotRoomData.isFirstGameInfo = false
            self.updatePlayerGold(walletBalance, accountBalance, 0)
        }
    }

    updatePlayerGold(gold: number, accountGold: number, time) {
        let self = this
        if (time == 0) {
            self.balanceLabel.string = "$" + Utility.numberFormat(gold)
            self.playAvatar.labelGold.string = GameUtil.currencyFormatting(accountGold)
        } else {
            SlotData.numberLaberAnim(self.slotRoomData.carryMoneyRecord, gold, time, (n) => {
                if (self.isDestroyed) return
                self.balanceLabel.string = "$" + Utility.numberFormat(n)
            }, function () {
                if (self.isDestroyed) return
                self.playAvatar.labelGold.string = GameUtil.currencyFormatting(accountGold);
            })
        }

        self.slotRoomData.ownMoneyRecord = accountGold
        self.slotRoomData.carryMoneyRecord = gold
    }
    updateOwnGold(accountGold) {
        if (this.slotRoomData.freeSpinStatus >= 0) {
            return
        }
        this.playAvatar.labelGold.string = GameUtil.currencyFormatting(accountGold)
    }

    updateWin(state, gold?: number, last?) {
        let self = this
        let playAnim = function (name) {
            self.bottomDragonLabel.node.active = true
            name = name == "SPINAGAIN" ? name + "2" : name
            self.bottomDragonLabel.playAnimation(name, name == "SPINAGAIN2" ? 0 : 1)
            self.bottomDragonLabel.once(dragonBones.EventObject.COMPLETE, function () {
                if (name == "SPINAGAIN2") {
                    return
                }
                self.bottomDragonLabel.playAnimation(name + "2", 0)
            })
        }
        let lastWinView = function () {
            if (self.slotRoomData.last_win_loss > 0) {
                self.bottomLastWin.node.active = true
                self.bottomLastWinNode.active = true
                self.bottomLastWin.string = "$" + Utility.numberFormat(self.slotRoomData.last_win_loss)//self.slotRoomData.last_win_loss + ""
            } else {
                self.bottomLastWin.node.active = false
                self.bottomLastWinNode.active = false
            }
        }
        if (state == 0) {
            playAnim("GOODLUCK")
            lastWinView()

        } else if (state == 1) {
            if (last) {
                playAnim("SPINAGAIN")
                if (gold > 0) {
                    self.bottomLastWin.node.active = true
                    self.bottomLastWinNode.active = true
                    self.bottomLastWin.string = "$" + Utility.numberFormat(gold)
                } else {
                    self.bottomLastWin.node.active = false
                    self.bottomLastWinNode.active = false
                }
            } else {
                if (gold > 0) {
                    playAnim("WIN")
                    self.bottomLastWin.node.active = true
                    self.bottomLastWinNode.active = false
                    SlotData.numberLaberAnim(0, gold, 1.5, (n) => {
                        if (self.isDestroyed) return
                        self.bottomLastWin.string = "$" + Utility.numberFormat(n)
                    })
                    let anim = self.slotAnim.getAnimByName("winAnim")
                    anim.node.active = true
                    anim.play()
                    anim.once("finished", function () {
                        anim.node.active = false
                    })
                } else {
                    playAnim("SPINAGAIN")
                    lastWinView()
                }
            }
        }
    }



    startAction(result: SlotGame.ISlotResult, actionMoney: number) {
        let self = this
        self.setFreeSpinStatus(-1)
        let tempCarryMoney = self.slotRoomData.carryMoneyRecord - actionMoney
        let tempOwnMoney = self.slotRoomData.ownMoneyRecord - actionMoney
        let r = self.slotRoomData.slotTestResult ? self.slotRoomData.slotTestResult : result
        if (actionMoney > 0) {
            self.slotRoomData.slotResult = r
            SlotData.setLocalRecord("SlotLastResult", JSON.stringify(r))
            self.slotRoomData.currentSlotResult = r
        } else {
            self.slotRoomData.currentSlotResult = result
        }
        self.updateWin(0)
        let win = self.slotRoomData.currentSlotResult.winAmount != null && self.slotRoomData.currentSlotResult.winAmount != undefined ? self.slotRoomData.currentSlotResult.winAmount : 0
        self.slotRoomData.win_loss = win
        if (win > 0) {
            self.slotRoomData.last_win_loss = win
        }
        self.clearState()
        self.slotRoomData.startActionScheduleId = self.doScheduleOnce(function () {
            self.endDeal()
        }, self.slotRoomData.cycleTime)
        let index = 0
        self.slotRoomData.cycleStatus = 1
        self.slotRoomData.tempSlotIconIndex = [0, 0, 0, 0, 0]
        self.doSchedule(function () {
            let no = index
            let anim = self.slotRoomData.slotEx[no].cycleAnim
            if (no == 0) {
                if (actionMoney > 0) {
                    self.updatePlayerGold(tempCarryMoney, tempOwnMoney, 0.8)
                }
                if (self.slotRoomData.freeSpinStatus < 0) {
                    SlotTableSound.pauseBgm()
                    anim.once("play", function () {
                        SlotTableSound.playSpinSound(self.slotRoomData.spinBgSound, function () { }, function (id) {
                            self.slotRoomData.spinSoundId = id
                        })
                    })
                }
                SlotTableSound.pauseSound(self.slotRoomData.effectSoundId)
            }
            for (let j = 0; j < self.slotRoomData.slotEx[no].columnList.length; j++) {
                self.slotRoomData.slotEx[no].columnList[j].icon.node.active = true
                self.slotRoomData.slotEx[no].columnList[j].fuzzyIcon.node.active = true
            }
            let goAnim = anim.getClips()[1]
            anim.play()
            anim.once("finished", function () {
                anim.play(goAnim.name)
                if (no == 4 && !self.slotRoomData.autoSpin && self.slotRoomData.freeSpinStatus < 0) {
                    self.buttonGreyManager.setButtonGrey("stop", false)
                }
            })
            index += 1
        }, 0.25, 4)
    }


    stopDeal() {
        let self = this
        if (self.slotRoomData.cycleStatus == 3) {
            if (self.slotRoomData.startFreeActionScheduleId != null) {
                self.cancelSchedule(self.slotRoomData.startFreeActionScheduleId)
                self.slotRoomData.startFreeActionScheduleId = null
            }
            self.stopFreeSpinEffect(self.slotRoomData.startFreeEffectColumn)
        } else {
            if (self.slotRoomData.startActionScheduleId != null) {
                self.cancelSchedule(self.slotRoomData.startActionScheduleId)
                self.slotRoomData.startActionScheduleId = null
            }
            self.endDeal()
        }
    }

    endDeal() {
        let self = this
        let index = 0

        self.buttonGreyManager.setButtonGrey("stop", true)
        let startFreeColumn = self.getFreeColumn()
        self.slotRoomData.startFreeEffectColumn = startFreeColumn + 1
        self.doSchedule(function () {
            let no = index
            let stopAnim = self.slotRoomData.slotEx[no].cycleAnim.getClips()[2]
            self.slotRoomData.cycleStatus = 2
            self.slotRoomData.slotEx[no].cycleAnim.play(stopAnim.name)
            let sp = self.rollerHaveSpecial(no)
            if (sp.length > 0) {
                for (let i = 0; i < sp.length; i++) {
                    self.playGridAnim(no, sp[i].column, sp[i].icon)
                }
            }
            self.slotRoomData.slotEx[no].cycleAnim.once("finished", function () {
                if (no == startFreeColumn) {
                    if (startFreeColumn < self.slotRoomData.slotEx.length - 1) {
                        self.startFreeSpinEffect(self.slotRoomData.startFreeEffectColumn)
                    } else {
                        self.setResult()
                    }
                }
            })
            index += 1
        }, 0.25, startFreeColumn)
    }
    setResult() {
        let self = this
        if (self.slotRoomData.currentSlotResult.paylines != undefined && self.slotRoomData.currentSlotResult.paylines.length > 0) {
            self.rewardResultView(self.slotRoomData.currentSlotResult.paylines)
        } else if (SlotData.rewardFreeSpinTimes(self.slotRoomData.currentSlotResult) > 0) {
            self.freeSpinResult(self.slotRoomData.currentSlotResult.freeSpin)
        } else {
            self.slotRoomData.cycleStatus = 0
            if (self.slotRoomData.autoSpin) {
                self.doScheduleOnce(function () {
                    EventManager.instance.dispatch("start_auto_spin", 0)
                }, 0.5)
            } else if (self.slotRoomData.freeSpinStatus > 0) {
                self.doScheduleOnce(function () {
                    self.startFreeSin(self.slotRoomData.freeSpinStatus)
                }, 0.5)
            } else {
                self.restoreInitialState()
                self.startBaseCycleLine()
            }
            self.updateWin(1, 0)
            self.resultUpdateGold(0)

            if (self.slotRoomData.freeSpinStatus < 0) {
                EventManager.instance.dispatch("Game_Table_Settlement", self.selfAvaterEffect)
            }
        }
    }

    resultUpdateGold(time) {
        let self = this
        if (self.slotRoomData.freeSpinStatus >= 0 || SlotData.rewardFreeSpinTimes(self.slotRoomData.currentSlotResult) > 0) {
            self.updatePlayerGold(self.slotRoomData.carryMoneyRecord + self.slotRoomData.win_loss, self.slotRoomData.ownMoneyRecord + self.slotRoomData.win_loss, time)
        } else {
            self.updatePlayerGold(self.slotRoomData.carryMoney, self.slotRoomData.ownMoney, time)
        }
    }

    getFreeColumn() {
        let self = this
        let fa = new Array()
        for (let i = 0; i < self.slotRoomData.currentSlotResult.windowSymbols.length; i++) {
            for (let j = 0; j < self.slotRoomData.currentSlotResult.windowSymbols[i].symbols.length; j++) {
                if (SlotData.serverSymbolToIcon(self.slotRoomData.currentSlotResult.windowSymbols[i].symbols[j]) == SlotFruit.Free) {
                    fa.push(j)
                }
            }
        }
        fa.sort((a, b) => a - b)
        if (fa.length >= 2) {
            return fa[1]
        } else {
            return self.slotRoomData.slotEx.length - 1
        }
    }

    startFreeSpinEffect(column) {
        let self = this
        for (let i = 0; i < self.slotRoomData.slotEx.length; i++) {
            self.slotRoomData.slotEx[i].freeAnim.node.active = i >= column
        }
        self.freeEffectNode.active = true
        self.slotRoomData.cycleStatus = 3
        SlotTableSound.stopSound(self.slotRoomData.spinSoundId)
        SlotTableSound.playFreeSpinCycle(null, function (id) {
            self.slotRoomData.spinSoundId = id
        })
        for (let i = column; i < self.slotRoomData.slotEx.length; i++) {
            self.slotRoomData.slotEx[i].freeAnim.play()
            self.slotRoomData.slotEx[i].freeAnim.once("finished", function () {
                let rollAnim = self.slotRoomData.slotEx[i].freeAnim.getClips()[1]
                self.slotRoomData.slotEx[i].freeAnim.play(rollAnim.name)

                if (i == self.slotRoomData.slotEx.length - 1) {
                    self.slotRoomData.startFreeActionScheduleId = self.doScheduleOnce(function () {
                        self.stopFreeSpinEffect(column)
                    }, self.slotRoomData.cycleTime)
                    self.buttonGreyManager.setButtonGrey("stop", false)
                }
            })
        }
    }

    stopFreeSpinEffect(column) {
        let self = this
        self.buttonGreyManager.setButtonGrey("stop", true)
        for (let i = column; i < self.slotRoomData.slotEx.length; i++) {
            let freeStopAnim = self.slotRoomData.slotEx[i].freeAnim.getClips()[2]
            let cycleStopAnim = self.slotRoomData.slotEx[i].cycleAnim.getClips()[2]
            self.doScheduleOnce(function () {
                self.slotRoomData.slotEx[i].cycleAnim.play(cycleStopAnim.name)
                self.slotRoomData.slotEx[i].freeAnim.play(freeStopAnim.name)
                let sp = self.rollerHaveSpecial(i)
                if (sp.length > 0) {
                    for (let j = 0; j < sp.length; j++) {
                        self.playGridAnim(i, sp[j].column, sp[j].icon)
                    }
                }
                self.slotRoomData.slotEx[i].freeAnim.once("finished", function () {
                    self.slotRoomData.slotEx[i].freeAnim.node.active = false
                    if (i == self.slotRoomData.slotEx.length - 1) {
                        if (SlotData.rewardFreeSpinTimes(self.slotRoomData.currentSlotResult) > 0) {
                            self.playFreeRewardGridAnim(function () {
                                self.doScheduleOnce(function () {
                                    self.setResult()
                                }, 0.5)
                            })
                        } else {
                            self.setResult()
                        }
                    }
                })
            }, 0.25 * (i - column))
        }
    }

    playFreeRewardGridAnim(callback) {
        let self = this
        let r = new Array()
        for (let i = 0; i < self.slotRoomData.currentSlotResult.windowSymbols.length; i++) {
            let sb = self.slotRoomData.currentSlotResult.windowSymbols[i].symbols
            for (let j = 0; j < sb.length; j++) {
                let f = SlotData.serverSymbolToIcon(sb[j])
                if (f == SlotFruit.Free) {
                    r.push({ hang: j, column: i, icon: "Free2" })
                }
            }
        }
        SlotTableSound.playFreeSpinHave()
        for (let i = 0; i < r.length; i++) {
            let func = i == r.length - 1 ? callback : null
            self.playGridAnim(r[i].hang, r[i].column, r[i].icon, func)
        }
    }
    playGridAnim(i, j, key, callback?) {
        let self = this
        let grid: SlotGrid = self.slotRoomData.slotEx[i].columnList[j + 1]
        let anim: dragonBones.ArmatureDisplay
        if (grid.anim instanceof dragonBones.ArmatureDisplay && grid.anim.node != null) {
            anim = grid.anim
        } else {
            let baseAnim = self.slotAnim.getGragonByName("gridicon")
            anim = SlotData.instantiateNode(baseAnim.node, grid.icon.node, "anim").getComponent(dragonBones.ArmatureDisplay)
            grid.anim = anim
        }
        anim.node.active = true
        grid.icon.enabled = false
        anim.playAnimation(key, 1)
        anim.once(dragonBones.EventObject.COMPLETE, function () {
            if (callback) {
                callback()
            }
        })
    }

    rollerHaveSpecial(index) {
        let self = this
        let r = new Array()
        for (let i = 0; i < self.slotRoomData.currentSlotResult.windowSymbols.length; i++) {
            let sb = self.slotRoomData.currentSlotResult.windowSymbols[i].symbols
            for (let j = 0; j < sb.length; j++) {
                let f = SlotData.serverSymbolToIcon(sb[j])
                if (f == SlotFruit.Wild && index == j) {
                    r.push({ column: i, icon: "Wild" })
                } else if (f == SlotFruit.Free && index == j) {
                    r.push({ column: i, icon: "Free" })
                } else if (f == SlotFruit.SEVEN && index == j) {
                    r.push({ column: i, icon: "777" })
                } else if (f == SlotFruit.DaXiang && index == j) {
                    r.push({ column: i, icon: "Bar" })
                }
            }
        }
        return r
    }

    setResultIcon(result?: SlotGame.ISlotResult, iconArray?) {
        let self = this
        let icons = []
        for (let i = 0; i < self.slotRoomData.slotEx.length; i++) {
            let iconIndex = Utility.randomToInt(0, self.slotRoomData.lineCycleSequence[i].length - 1)
            icons[i] = []
            for (let j = 0; j < self.slotRoomData.slotEx[i].columnList.length; j++) {
                let obj = self.slotRoomData.slotEx[i].columnList[j].icon
                let fuzzy = self.slotRoomData.slotEx[i].columnList[j].fuzzyIcon
                let icon = ""
                if (result && j > 0 && j < 4) {
                    icon = SlotData.serverSymbolToIcon(result.windowSymbols[j - 1].symbols[i])
                } else if (iconArray && iconArray[i] != undefined && iconArray[i][j] != undefined) {
                    icon = iconArray[i][j]
                }
                if (!self.spriteHoder.setSprite(obj, icon)) {
                    let inx = (iconIndex + j) % self.slotRoomData.lineCycleSequence[i].length
                    icon = self.slotRoomData.lineCycleSequence[i][inx]
                    self.spriteHoder.setSprite(obj, icon)
                }
                icons[i][j] = icon
                self.spriteHoder.setSprite(fuzzy, `${icon}Fuzzy`)
            }
        }
        SlotData.setLocalRecord("SlotLastIconArray", icons.toString())
    }

    startBaseCycleLine() {
        let self = this
        self.slotRoomData.defaultCycleScheduleId = self.doScheduleOnce(function () {
            self.slotTableLine.cycleBaseLine()
        }, 5)
    }

    restoreInitialState(freeStatus?) {
        let self = this
        self.buttonGreyManager.setButtonGrey("info", false)
        self.buttonGreyManager.setButtonGrey("carry", false)
        self.buttonGreyManager.setButtonGrey("add", self.slotRoomData.curMultiple == self.slotRoomData.roomRule.maxMultiple)
        self.buttonGreyManager.setButtonGrey("reduce", self.slotRoomData.curMultiple == self.slotRoomData.roomRule.minMultiple)
        self.buttonGreyManager.setButtonGrey("max", false)
        self.buttonGreyManager.setButtonGrey("auto", false)
        self.autoActiveBg.active = false
        self.autoFlagNode.active = self.slotRoomData.autoSpin
        self.setFreeSpinStatus(freeStatus != null ? freeStatus : -1)

        self.stopBtn.node.active = false
        self.startBtn.node.active = true
        self.doScheduleOnce(() => {
            SlotTableSound.resumeBgm()
            SlotTableSound.resumeSound(self.slotRoomData.effectSoundId)
        }, 0.5)
    }
    resultMaxComb(payLines) {
        let comb = 0
        for (let i = 0; i < payLines.length; i++) {
            if (payLines[i].comboCount > comb) {
                comb = payLines[i].comboCount
            }
        }
        return comb
    }

    clearState() {
        let self = this
        self.slotTableLine.endCycleLine()
        if (self.slotRoomData.defaultCycleScheduleId != null) {
            self.cancelSchedule(self.slotRoomData.defaultCycleScheduleId)
            self.slotRoomData.defaultCycleScheduleId = null
        }
        if (!self.slotRoomData.autoSpin) {
            self.startBtn.node.active = false
            self.stopBtn.node.active = true
            self.buttonGreyManager.setButtonGrey("info", true)
            self.buttonGreyManager.setButtonGrey("carry", true)
            self.buttonGreyManager.setButtonGrey("add", true)
            self.buttonGreyManager.setButtonGrey("reduce", true)
            self.buttonGreyManager.setButtonGrey("max", true)
            self.buttonGreyManager.setButtonGrey("stop", true)
            self.buttonGreyManager.setButtonGrey("auto", true)
        }
    }

    generateIconCycleSequence() {
        let self = this
        let wildNum = [Utility.randomToInt(5, 15), Utility.randomToInt(5, 15), Utility.randomToInt(5, 15)]
        let maxNum = SlotData.defaultIconCycleSequence.length * 3 - 1
        let wildPos = [SlotData.randonPointRangeNumber(0, maxNum, wildNum[0]), SlotData.randonPointRangeNumber(0, maxNum, wildNum[1]), SlotData.randonPointRangeNumber(0, maxNum, wildNum[2])]
        for (let i = 0; i < SlotData.defaultIconCycleSequence.length; i++) {
            self.slotRoomData.lineCycleSequence[i] = []
            for (let j = 0; j < SlotData.defaultIconCycleSequence[i].length; j++) {
                for (let k = 0; k < 3; k++) {
                    self.slotRoomData.lineCycleSequence[i][3 * j + k] = SlotData.defaultIconCycleSequence[i][j]
                }
            }
        }
        for (let i = 1; i < self.slotRoomData.lineCycleSequence.length - 1; i++) {
            for (let j = 0; j < self.slotRoomData.lineCycleSequence[i].length; j++) {
                if (wildPos[i - 1].indexOf(j) > 0) {
                    self.slotRoomData.lineCycleSequence[i][j] = SlotFruit.Wild
                }
            }
        }
    }

    initGrid() {
        let self = this
        for (let i = 0; i < self.slotRoomData.slotEx.length; i++) {
            let iconIndex = Utility.randomToInt(0, self.slotRoomData.lineCycleSequence[i].length - 1)
            self.slotRoomData.curSlotIconIndex[i] = (iconIndex + self.slotRoomData.slotEx[i].columnList.length) % self.slotRoomData.lineCycleSequence[i].length
            self.slotRoomData.slotEx[i].columnNode = self.gridParent.getChildByName((i + 1) + "")
            self.slotRoomData.slotEx[i].cycleAnim = self.slotRoomData.slotEx[i].columnNode.getComponent(cc.Animation)
            self.slotRoomData.slotEx[i].freeAnim = self.freeEffectNode.getChildByName("FreeRolling" + (i + 1)).getComponent(cc.Animation)
            self.slotRoomData.slotEx[i].cycleEvent = self.slotRoomData.slotEx[i].columnNode.getComponent(SlotCycleEvent)
            self.slotRoomData.slotEx[i].cycleEvent.initEvent(self.slotRoomData, self.spriteHoder)
            for (let j = 0; j < self.slotRoomData.slotEx[i].columnList.length; j++) {
                self.slotRoomData.slotEx[i].columnList[j].grid = self.slotRoomData.slotEx[i].columnNode.getChildByName((j + 1) + "")
                self.slotRoomData.slotEx[i].columnList[j].icon = self.slotRoomData.slotEx[i].columnList[j].grid.getChildByName("Icon").getComponent(cc.Sprite)
                self.slotRoomData.slotEx[i].columnList[j].fuzzyIcon = self.slotRoomData.slotEx[i].columnList[j].grid.getChildByName("FuzzyIcon").getComponent(cc.Sprite)
                self.slotRoomData.slotEx[i].columnList[j].icon.node.active = true
                self.slotRoomData.slotEx[i].columnList[j].fuzzyIcon.node.active = false
            }
        }
    }

    freeSpinResult(freeSpin: SlotGame.SlotResult.IFreeSpinResult) {
        let self = this
        self.slotRoomData.freeAutoSpin = self.slotRoomData.autoSpin
        self.slotRoomData.autoSpin = false
        self.setFreeSpinStatus(0)
        self.startFreeLabel.opacity = 0
        self.startFreeLabel.runAction(cc.fadeIn(0.2))
        self.playFullAnim("freeStart", freeSpin.records.length + "")
    }
    setFreeSpinStatus(status: number) {
        this.slotRoomData.freeSpinStatus = status
        SlotData.setLocalRecord("SlotFreeSpinStatus", status)
        if (status == 0) {
            SlotData.setLocalRecord("SlotFreeSpinBeishu", this.slotRoomData.curMultiple)
        }
    }


    rewardResultView(paylines: SlotGame.SlotResult.IPayline[]) {
        let self = this
        let func = function () {
            self.slotRoomData.cycleStatus = 0
            self.slotTableLine.showAllRewardLine(paylines, function () {
                SlotTableSound.playNumberCycleSound()
                self.updateWin(1, self.slotRoomData.win_loss)
                if (!self.slotRoomData.reconnectFreeSpin) {
                    self.resultUpdateGold(1.5)
                    self.flyAvatarWinGold(self.slotRoomData.win_loss)
                }
            }, function () {
                if (SlotData.rewardFreeSpinTimes(self.slotRoomData.currentSlotResult) > 0) {
                    self.freeSpinResult(self.slotRoomData.currentSlotResult.freeSpin)
                } else {
                    if (self.slotRoomData.autoSpin) {
                        self.doScheduleOnce(function () {
                            EventManager.instance.dispatch("start_auto_spin", paylines)
                        }, 0.5)
                    } else if (self.slotRoomData.freeSpinStatus > 0) {
                        self.doScheduleOnce(function () {
                            self.startFreeSin(self.slotRoomData.freeSpinStatus)
                        }, 0.5)
                    } else {
                        self.restoreInitialState()
                        self.showBoxLine(paylines)
                    }
                }
                if (self.slotRoomData.freeSpinStatus < 0) {
                    EventManager.instance.dispatch("Game_Table_Settlement", self.selfAvaterEffect)
                }
            })
        }
        if (self.slotRoomData.win_loss >= self.slotRoomData.bigwinCount[0]) {
            if (self.slotRoomData.win_loss < self.slotRoomData.bigwinCount[1]) {
                self.slotRoomData.playAnimStatus = 3
                self.playFullAnim("bigwin", "BigWin", func)
                self.playAvatarAnim("BigWin")
            } else if (self.slotRoomData.win_loss < self.slotRoomData.bigwinCount[2]) {
                self.slotRoomData.playAnimStatus = 4
                self.playFullAnim("bigwin", "HugeWin", func)
                self.playAvatarAnim("HugeWin")
            } else {
                self.slotRoomData.playAnimStatus = 5
                self.playFullAnim("bigwin", "SuperWin", func)
                self.playAvatarAnim("SuperWin")
            }
        } else {
            let combNum = self.resultMaxComb(paylines)
            if (combNum > 3) {
                self.slotRoomData.playAnimStatus = 1
                if (combNum == 4) {
                    self.playFullAnim("ofkind", "4_of_a_kind", func)
                    self.playAvatarAnim("4ofaKind")
                } else if (combNum == 5) {
                    self.playFullAnim("ofkind", "5_of_a_kind", func)
                    self.playAvatarAnim("5ofaKind")
                }
            } else {
                func()
            }
        }
    }

    playAvatarAnim(name) {
        // let dragon = this.slotAnim.getGragonByName("avatarAnim")
        // dragon.node.active = true
        // dragon.playAnimation(name, 1)
        // dragon.once(dragonBones.EventObject.COMPLETE, function () {
        //     dragon.node.active = false
        // })
    }

    showBoxLine(paylines: SlotGame.SlotResult.IPayline[]) {
        this.slotTableLine.showBoxLine(paylines)
    }
    flyAvatarWinGold(gold: number) {
        let self = this
        self.selfWinGoldLabel.string = "+" + Utility.numberFormat(gold)
        self.selfWinGoldLabel.node.active = true
        self.selfWinGoldLabel.node.opacity = 0
        self.selfWinGoldLabel.node.position = new cc.Vec3(0, 0)
        self.selfWinGoldLabel.node.runAction(cc.fadeIn(0.2))
        self.selfWinGoldLabel.node.runAction(cc.sequence([cc.moveTo(0.5, new cc.Vec2(0, 150)), cc.callFunc(function () {
            self.scheduleOnce(function () {
                self.selfWinGoldLabel.node.runAction(cc.fadeOut(0.5))
            }, 1)
        }.bind(self))]))
    }

    animContinue() {
        let self = this
        let anim = self.slotAnim.getAnimByName("freeEnd")
        let dragon = self.slotAnim.getGragonByName("freeStart")
        self.animContinueBtn.active = false
        if (self.slotRoomData.freeSpinStatus == 0) {
            self.animMengban.runAction(cc.fadeTo(0.2, 0))
            dragon.playAnimation(self.slotRoomData.slotResult.freeSpin.records.length + "out", 1)
            self.startFreeLabel.runAction(cc.fadeOut(0.4))
            dragon.once(dragonBones.EventObject.COMPLETE, function () {
                self.animMengban.runAction(cc.sequence([cc.fadeTo(0.2, 0), cc.callFunc(function () {
                    self.animNode.active = false
                    dragon.node.active = false
                    self.startFreeSin(0, true)
                }.bind(self))]))
            })
        } else {
            let out = anim.getClips()[2]
            anim.play(out.name)
            anim.once("finished", function () {
                self.animMengban.runAction(cc.sequence([cc.fadeTo(0.2, 0), cc.callFunc(function () {
                    self.animNode.active = false
                    anim.node.active = false
                    self.restoreInitialState(-2)
                    SlotTableSound.stopBgm()
                    SlotTableSound.playBgm()
                    let freeanim = self.slotAnim.getAnimByName("freeSpin")
                    let clip = freeanim.getClips()[1]
                    freeanim.play(clip.name)
                    freeanim.once("finished", function () {
                        self.freeSpinNode.active = false
                    })
                    self.slotRoomData.autoSpin = self.slotRoomData.freeAutoSpin
                    self.slotRoomData.freeAutoSpin = false
                    if (self.slotRoomData.autoSpin) {
                        self.setAutoSpin(this.slotRoomData.autoSpin, this.slotRoomData.curMultiple)
                        EventManager.instance.dispatch("start_auto_spin", 0)
                    }
                }.bind(self))]))
            })
        }
    }

    startFreeSin(times, first?) {
        let self = this
        let len = self.slotRoomData.slotResult.freeSpin.records.length
        if (len > times) {
            self.freeSpinTimes.string = (len - self.slotRoomData.freeSpinStatus) + ""
            if (first) {
                self.freeSpinNode.active = true
                let anim = self.slotAnim.getAnimByName("freeSpin")
                let clip = anim.getClips()[0]
                anim.play(clip.name)
            }
            self.startAction(self.slotRoomData.slotResult.freeSpin.records[times], 0)
            self.setFreeSpinStatus(times + 1)
        } else {
            self.setFreeSpinStatus(-2)
            self.freeSpinWinGoldLabel.string = Utility.numberFormat(self.slotRoomData.slotResult.freeSpin.winAmount)
            self.playFullAnim("freeEnd")
            if (self.slotRoomData.reconnectFreeSpin) {
                self.slotRoomData.reconnectFreeSpin = false
                self.slotRoomData.setbigwinCount(self.slotRoomData.curMultiple)
            }
        }
    }


    playFullAnim(key, name?, func?) {
        let self = this
        self.bottomDragonLabel.node.active = false
        self.animNode.active = true
        self.animMengban.opacity = 0
        self.animMengban.runAction(cc.fadeTo(0.3, 220))
        if (key == "bigwin") {
            self.winAnimNumberLabel.string = ""
            self.winAnimNumberLabel.node.opacity = 0
            self.winAnimNumberLabel.node.runAction(cc.fadeIn(0.5))
        }
        let dragon: dragonBones.ArmatureDisplay = self.slotAnim.getGragonByName(key)
        let anim: cc.Animation = self.slotAnim.getAnimByName(key)
        dragon.node.active = true
        if (key == "freeEnd") {
            anim.node.active = true
            let sa = anim.getClips()[0]
            anim.play(sa.name)
            dragon.playAnimation("JinBi", 1)
            anim.once("finished", function () {
                self.bottomDragonLabel.node.active = true
                self.animContinueBtn.opacity = 0
                self.animContinueBtn.active = true
                self.animContinueBtn.runAction(cc.fadeIn(0.1))
                let stop = anim.getClips()[1]
                anim.play(stop.name)
            })
        } else {
            dragon.once(dragonBones.EventObject.COMPLETE, function () {
                self.slotRoomData.playAnimStatus = 0
                self.bottomDragonLabel.node.active = true
                if (key == "freeStart") {
                    self.animContinueBtn.opacity = 0
                    self.animContinueBtn.active = true
                    self.animContinueBtn.runAction(cc.fadeIn(0.1))
                } else {
                    self.animContinueBtn.active = false
                    self.animMengban.runAction(cc.sequence([cc.fadeTo(0.2, 0), cc.callFunc(function () {
                        self.animNode.active = false
                        dragon.node.active = false
                        if (func) {
                            func()
                        }
                    }.bind(self))]))
                    if (key == "bigwin") {
                        self.winAnimNumberLabel.node.runAction(cc.fadeOut(0.15))
                    }
                }
                dragon.off(dragonBones.EventObject.FRAME_EVENT)
            })
            dragon.on(dragonBones.EventObject.FRAME_EVENT, function (event: any) {
                let en = event.name
                let du = 2.2   // event.data.floats[0]
                let startNumber = 0
                let endNumber = 0
                let vt = 0
                if (en == "BiwinStart" || en == "BigwinStart") {
                    SlotTableSound.playBigWinSound()
                    startNumber = 0
                    endNumber = name == "BigWin" ? self.slotRoomData.win_loss : self.slotRoomData.bigwinCount[1]
                } else if (en == "HugewinStart") {
                    SlotTableSound.playHugeWinSound()
                    startNumber = self.slotRoomData.bigwinCount[1]
                    endNumber = name == "HugeWin" ? self.slotRoomData.win_loss : self.slotRoomData.bigwinCount[2]
                    du = 2.3
                } else if (en == "SuperwinStart") {
                    SlotTableSound.playSuperWinSound()
                    startNumber = self.slotRoomData.bigwinCount[2]
                    endNumber = self.slotRoomData.win_loss
                    du = 2.3
                }
                SlotData.numberLaberAnim(startNumber, endNumber, du, (n) => {
                    if (!self.isDestroyed) {
                        let nowTime = new Date().getTime()
                        if (nowTime - vt > 40) {
                            self.winAnimNumberLabel.string = Utility.numberFormat(n)
                            vt = new Date().getTime()
                        }
                    }
                })
            })
            dragon.playAnimation(name, 1)
        }
        if (key == "ofkind") {
            SlotTableSound.playOfkindSound()
        } else if (key == "bigwin") {
            SlotTableSound.playBigWinSound()
        } else if (key == "freeStart") {
            if (!self.slotRoomData.reconnectFreeSpin) {
                // SlotTableSound.playFreeSpinReward(function () {
                // if (!self.isDestroyed) {
                //     SlotTableSound.playFreeBgm()
                // }
                // })
                SlotTableSound.playFreeSpinReward()
                SlotTableSound.playFreeBgm()
            }
        } else if (key == "freeEnd") {
            SlotTableSound.playFreeSpinEnd()
            SlotTableSound.playFreeSpinCoin()
        }
    }



    testLine() {
        let str = this.slotTableLine.testEditor.string
        if (str == "start") {
            this.startFreeLabel.opacity = 0
            this.startFreeLabel.runAction(cc.fadeIn(0.2))
            this.playFullAnim("freeStart", "10")
        } else if (str == "end") {
            this.freeSpinWinGoldLabel.string = Utility.numberFormat(2000)
            this.playFullAnim("freeEnd")
        } else if (str == "continue") {
            this.startFreeSin(this.slotRoomData.freeSpinStatus)
        } else if (str == "light") {
            this.slotTableLine.endCycleLine()
            this.slotTableLine.showAllRewardLine(this.slotRoomData.slotTestResult.paylines)
        } else {
            this.slotTableLine.testLine()
        }
    }
    testKuang() {
        let self = this
        let str = this.slotTableLine.testEditor.string
        if (str == "start") {
            let dragon = self.slotAnim.getGragonByName("freeStart")
            self.animContinueBtn.active = false
            self.animMengban.runAction(cc.fadeTo(0.2, 0))
            dragon.playAnimation("10out", 1)
            self.startFreeLabel.runAction(cc.fadeOut(0.4))
            dragon.once(dragonBones.EventObject.COMPLETE, function () {
                self.animMengban.runAction(cc.sequence([cc.fadeTo(0.2, 0), cc.callFunc(function () {
                    self.animNode.active = false
                    dragon.node.active = false
                }.bind(self))]))
            })
        } else if (str == "end") {
            let anim = self.slotAnim.getAnimByName("freeEnd")
            let out = anim.getClips()[2]
            anim.play(out.name)
            anim.once("finished", function () {
                self.animMengban.runAction(cc.sequence([cc.fadeTo(0.2, 0), cc.callFunc(function () {
                    self.animNode.active = false
                    anim.node.active = false
                }.bind(self))]))
            })
        } else if (str == "dragon") {
            self.playFullAnim("bigwin", "SuperWin")
        } else {
            this.slotTableLine.testKuang()
        }
    }
    testHuifu() {
        this.slotTableLine.testHuifu()
    }
    on_destroy() {
        this.slotRoomData.isFirstGameInfo = true
        this.slotTableLine.on_destroy()
        this.cancelAllSchedule()
    }


}

